
import { h, Fragment } from 'preact'
import classnames from 'classnames'

export function FieldContainer({ error, children, ...props }) {
	const classes = classnames(
		'field-container',
		'first-last',
		error && 'field-container--error',
		props['class'],
		props['className'],		
	)
	delete props['class']
	delete props['className']

	return <>
		<div class={classes} {...props}>
			{children}
			{error && <div class="field-container__error">{error}</div>}
		</div>
	</>
}